import { createMuiTheme } from "@material-ui/core/styles";
import { titanStyle } from "../../style/titan.theme.constant";
export const getMuiTheme = (renderType) =>
  createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {
        root: {
          fontSize: titanStyle.titan_fontSize.fontSize_14,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: 1.21,
          letterSpacing: titanStyle.titan_letterSpacing._normal,
          textAlign: titanStyle.titan_textAlign._left,
          color: titanStyle.titan_color.color_black,
          fontWeight: titanStyle.titan_fontWeigth.fontWeigth_500,
          textTransform: "capitalize",
          padding: " 15px 10px 15px 10px",
          height: "40px",
        },
      },
      MUIDataTableBodyCell: {
        root: {
          fontSize: titanStyle.titan_fontSize.fontSize_12,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: 1.21,
          letterSpacing: "normal",
          textAlign: titanStyle.titan_textAlign._left,
          color: titanStyle.titan_color.color_black,
          fontWeight: titanStyle.titan_fontWeigth.fontWeigth_normal,
          cursor: "pointer",
        },
      },
      MuiTablePagination: {
        root: {
          fontSize: titanStyle.titan_fontSize.fontSize_12,
          fontWeight: titanStyle.titan_fontWeigth._normal,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: 1.17,
          letterSpacing: "normal",
          textAlign: titanStyle.titan_textAlign._left,
          color: titanStyle.titan_color.color_warm_grey_two,
        },
      },
      MuiTableFooter: {
        root: {
          display: "flex",
          backgroundColor: "#fff",
        },
      },
      MuiToolbar: {
        root: {
          padding: "0px !important",
        },
      },
      MUIDataTablePagination: {
        root: {
          padding: "0px 24px 0px 15px !important",
        },
      },
      MuiTableCell: {
        root: {
          height: "40px",
          padding: "10px",
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: renderType !== "List" ? "#f5f5f5" : "#fff",
          boxShadow:
            renderType !== "List" ? "none !important" : "none !important",
          borderBottom: "1px solid rgba(224, 224, 224, .5)",
        },
      },
      MuiTableHead: {
        root: {
          display: renderType !== "List" ? "none" : "",
        },
      },
    },
  });
